export default __webpack_public_path__ + "static/media/fire-damages.0f82b838.png";